import React, { Component } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  notification,
  Popconfirm,
  message,
  Row,
  Col,
  Typography,
  Collapse,
  Form,
} from "antd";
import Highlighter from "react-highlight-words";
import {
  SearchOutlined,
  DeleteFilled,
  EditFilled,
  FilterFilled,
  RestFilled,
} from "@ant-design/icons";
import axios from "axios";
import { Link } from "react-router-dom";

const { Title } = Typography;

class TableGames extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: "",
      searchedColumn: "",
      games: [],
      isLoading: true,
      isFilterActive: false,
      inputFilter: {
        release: "",
        genre: "",
        platform: "",
      },
    };
  }

  componentDidMount() {
    if (this.state.isLoading) {
      this.fetchGames();
    }
  }

  componentDidUpdate() {
    if (this.state.isLoading) {
      this.fetchGames();
    }
  }

  fetchGames = () => {
    axios
      .get("https://backendexample.sanbersy.com/api/data-game")
      .then((res) => {
        let data;

        if (!this.state.isFilterActive) {
          data = res.data;
        } else {
          const { release, genre, platform } = this.state.inputFilter;

          const filtered = res.data.filter((value) => {
            if (release !== "" && value.release === release) {
              return true;
            }

            if (genre !== "" && value.genre.toLowerCase().includes(genre)) {
              return true;
            }

            if (
              platform !== "" &&
              value.platform.toLowerCase().includes(platform)
            ) {
              return true;
            }

            return false;
          });

          data = filtered;

          // console.log(filtered);
        }

        const list = data.map((value, index) => {
          return {
            ...value,
            key: value.id,
            no: index + 1,
            singlePlayer:
              value.singlePlayer === 1 ? "Available" : "Not Available",
            multiplayer:
              value.multiplayer === 1 ? "Available" : "Not Available",
            action: (
              <>
                <Link to={`/admin/edit-game/${value.id}`}>
                  <Button
                    type="text"
                    icon={<EditFilled style={{ color: "#fadb14" }} />}
                  />
                </Link>{" "}
                ||{" "}
                <Popconfirm
                  placement="top"
                  title="Are you sure to delete this game?"
                  onConfirm={() => {
                    this.handleDelete(value.id);
                  }}
                  okText="Yes"
                  cancelText="No"
                >
                  <Button
                    type="text"
                    icon={<DeleteFilled style={{ color: "#f5222d" }} />}
                  />
                </Popconfirm>
              </>
            ),
          };
        });

        this.setState({
          games: list,
          isLoading: false,
        });
      })
      .catch((err) => {
        notification.error({
          message: "Error Loading Data",
          description: err.response.data.message,
          placement: "topRight",
        });

        console.log(err.response.data.message);
        this.setState({
          isLoading: false,
        });
      });
  };

  handleChange = (e) => {
    this.setState({
      inputFilter: {
        ...this.state.inputFilter,
        [e.target.name]: e.target.value,
      },
    });
  };

  resetFilter = () => {
    this.setState({
      inputFilter: {
        release: "",
        platform: "",
        genre: "",
      },
      isFilterActive: false,
      isLoading: true,
    });
  };

  onFinish = () => {
    const { release, genre, platform } = this.state.inputFilter;
    if (release === "" && genre === "" && platform === "") {
      message.info({ content: "Please provide at least one filter parameter" });
    } else {
      this.setState({
        isFilterActive: true,
        isLoading: true,
      });
    }
  };

  handleDelete = async (id) => {
    const user = JSON.parse(localStorage.getItem("user"));

    try {
      const res = await axios.delete(
        `https://backendexample.sanbersy.com/api/data-game/${id}`,
        {
          headers: { Authorization: "Bearer " + user.token },
        }
      );

      this.setState({
        isLoading: true,
      });

      message.success({ content: "Game deleted successfully" });
    } catch (error) {
      message.error({ content: "Error deleting game" });
      console.log(error.response);
    }
  };

  getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ marginBottom: 8, display: "block" }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => this.handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              this.setState({
                searchText: selectedKeys[0],
                searchedColumn: dataIndex,
              });
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase())
        : "",
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: (text) =>
      this.state.searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: "#ffc069", padding: 0 }}
          searchWords={[this.state.searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ""}
        />
      ) : (
        text
      ),
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = (clearFilters) => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  render() {
    const columns = [
      {
        title: "No",
        dataIndex: "no",
        key: "no",
        width: "7%",
        sorter: (a, b) => a.no - b.no,
      },
      {
        title: "Name",
        dataIndex: "name",
        key: "name",
        sorter: (a, b) => a.name.length - b.name.length,
        ...this.getColumnSearchProps("name"),
      },
      {
        title: "Platform",
        dataIndex: "platform",
        key: "platform",
        ellipsis: true,
        sorter: (a, b) => a.platform.length - b.platform.length,
      },
      {
        title: "Release",
        dataIndex: "release",
        key: "release",
        sorter: (a, b) => a.release - b.release,
      },
      {
        title: "Genre",
        dataIndex: "genre",
        key: "genre",
        ellipsis: true,
        sorter: (a, b) => a.genre.length - b.genre.length,
      },
      {
        title: "Single Player",
        dataIndex: "singlePlayer",
        key: "singlePlayer",
        sorter: (a, b) => a.singlePlayer.length - b.singlePlayer.length,
      },
      {
        title: "Multi Player",
        dataIndex: "multiplayer",
        key: "multiplayer",
        ellipsis: true,
        sorter: (a, b) => a.multiplayer.length - b.multiplayer.length,
      },
      {
        title: "Action",
        dataIndex: "action",
        key: "action",
      },
    ];

    return (
      <>
        <Row>
          <Col span={24}>
            <Collapse bordered={true}>
              <Collapse.Panel header="Expand Filter" key="filter">
                <Title level={5}>Filter Games</Title>
                <Form
                  name="basic"
                  layout="vertical"
                  wrapperCol={{ span: 24 }}
                  value={{ remember: false }}
                  onFinish={this.onFinish}
                >
                  <Form.Item
                    label="Release"
                    rules={[
                      {
                        required: true,
                        message: "Please input game release year!",
                      },
                    ]}
                  >
                    <div className="ant-input-number" style={{ width: "100%" }}>
                      <div className="ant-input-number-input-wrap">
                        <input
                          className="ant-input-number-input"
                          type="number"
                          placeholder="Input game release year"
                          name="release"
                          min="2000"
                          max="2021"
                          value={this.state.inputFilter.release}
                          onChange={this.handleChange}
                        />
                      </div>
                    </div>
                  </Form.Item>
                  <Form.Item
                    label="Genre"
                    rules={[
                      { required: true, message: "Please input game genre!" },
                    ]}
                  >
                    <input
                      className="ant-input"
                      type="text"
                      placeholder="Input game genre"
                      name="genre"
                      value={this.state.inputFilter.genre}
                      onChange={this.handleChange}
                    />
                  </Form.Item>
                  <Form.Item label="Platform">
                    <input
                      className="ant-input"
                      type="text"
                      placeholder="Input game platform"
                      name="platform"
                      value={this.state.inputFilter.platform}
                      onChange={this.handleChange}
                    />
                  </Form.Item>
                  <Form.Item wrapperCol={{ span: 24 }}>
                    <Button
                      type="primary"
                      htmlType="submit"
                      block
                      icon={<FilterFilled />}
                      loading={this.state.isLoading}
                    >
                      Filter Game
                    </Button>
                  </Form.Item>
                </Form>
                <Button
                  type="default"
                  htmlType="submit"
                  block
                  icon={<RestFilled />}
                  onClick={this.resetFilter}
                  loading={this.state.isLoading}
                >
                  Reset
                </Button>
              </Collapse.Panel>
            </Collapse>
          </Col>
        </Row>
        <Row style={{ marginTop: 24 }}>
          <Col span={24}>
            <Table
              bordered={true}
              columns={columns}
              dataSource={this.state.games}
              loading={this.state.isLoading}
              pagination={{ position: ["bottomRight"] }}
            />
          </Col>
        </Row>
      </>
    );
  }
}

export default TableGames;
